module.exports = __webpack_public_path__ + "img/contentImg.417bf4ad.png";